import { time } from '@/utilities/timeUtils';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';

import { MinimalEvent } from '@/generated/model/minimalEvent';

import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

export function RouteEventDetail({ events }: { events: MinimalEvent[] | undefined }) {
  if (!events) return null;
  return (
    <>
      <TableContainer component={Paper}>
        <Table className="route-event-detail-table">
          <TableBody>
            {events.map((event) => (
              <TableRow key={event.eventTimeMicros} className="route-event-detail-table-row">
                <TableCell sx={{ width: 60 }}>
                  <Typography variant="body2">{time(event.eventTimeMicros)}</Typography>
                </TableCell>
                <TableCell sx={{ width: 60 }}>
                  <LocalShippingIcon className="route-event-detail-icon" />
                  {event.marker == 'running' && <DoubleArrowIcon className="route-event-detail-icon" />}
                  {event.marker == 'standing' && <HourglassEmptyIcon className="route-event-detail-icon" />}
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ lineHeight: 1 }}>
                    {event.description}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'grey.800', lineHeight: 1 }}>
                    #{event.code}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
